/* eslint-disable no-unused-vars */
import HandleResponsesV2 from '@common/utils/handleApiResponsesV2';
import downloadFile from '@common/utils/downloadFile';
import axios from '../../../axios';

const actions = {
  async filter({ commit }, { params }) {
    try {
      let result = [];
      if (params.page === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      result = await axios.put('/v2/shipper/wallet', { params });

      if (result && result.data) {
        commit('SET_LIST', result);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },

  async getDetails({ commit }, { params }) {
    try {
      let result = [];
      result = await axios.put('/v2/shipper/wallet', { params });
      commit('SET_DETAILS', null);
      if (result && result.data) {
        commit('SET_DETAILS', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addComment(_, payload) {
    try {
      const result = await axios.post('/v2/shipper/wallet/comment', payload);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async acceptWallet({ commit }, { payload }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/status', { data: payload });
      // if (result && result.data) {
      //   commit('UPDATE_LIST', result.data);
      // }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async rejectWallet({ commit }, { payload }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/status', { data: payload });
      // if (result && result.data) {
      //   commit('UPDATE_LIST', result.data);
      // }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async export(_, payload) {
    try {
      const headers = { responseType: 'blob' };
      const result = await axios.post('v2/shipper/wallet/export', payload, headers);
      return result;
    } catch (error) {
      return error;
    }
  },
  async markUsed(_, { data }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/update', { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async waiveOffWallet(_, { data }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/waive-off', { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addAttachment(_, formData) {
    try {
      const result = await axios.post('/v2/shipper/attachment/',
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async deleteAttachment({ commit }, { attachmentId }) {
    try {
      const result = await axios.delete(`/v2/shipper/attachment/${attachmentId}`);
      commit('REMOVE_ATTACHMENT', attachmentId);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async downloadSampleWallet() {
    try {
      const response = await axios.get('v2/shipper/wallet/sample-download', {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async uploadWallet({ commit }, { formData }) {
    commit('WALLET_BULK_PROCESSING', true);
    try {
      const result = await axios.post('v2/shipper/wallet/bulk-upload', formData);
      return result;
    } catch (error) {
      commit('WALLET_BULK_PROCESSING', false);
      return error;
    }
  },
  async getWalletBulkUploadStatus(_, query) {
    try {
      const response = await axios.get('v2/shipper/wallet/bulk-upload-status', {
        params: query,
      });
      return response;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async downloadRejectedFile(_, query) {
    try {
      const response = await axios.get('v2/shipper/wallet/download-rejected-file', {
        params: query,
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async markGenerated(_, { data }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/approve-generated', { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async rejectDraft(_, { data }) {
    try {
      const result = await axios.put('/v2/shipper/wallet/reject-draft', { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getWalletCustomFields(_, { walletId }) {
    try {
      const result = await axios.get(`/v2/shipper/wallet/custom-fields/${walletId}/list`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateWalletCustomFields(_, { walletId, payload }) {
    try {
      const result = axios.post(`/v2/shipper/wallet/custom-fields/${walletId}/create`, payload);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async getWalletTimelineAndRemarks(_, { walletId }) {
    try {
      const result = await axios.get(`/v2/shipper/wallet/${walletId}/timeline-remarks`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
};
export default actions;
